import { render, staticRenderFns } from "./simple-choice-popup.vue?vue&type=template&id=48b44122&scoped=true&"
import script from "./simple-choice-popup.vue?vue&type=script&lang=ts&"
export * from "./simple-choice-popup.vue?vue&type=script&lang=ts&"
import style0 from "./simple-choice-popup.vue?vue&type=style&index=0&id=48b44122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b44122",
  null
  
)

export default component.exports